module.exports = __webpack_public_path__ + "img/招标信息Mobile.c3be5366.jpg";